export default {
  en: {
    yandex: 'Sign in with Yandex ID',
    vk: 'Sign in with VK ID',
    soon: 'soon',
    failed: 'Couldn’t sign in. Please try again.',
    connect_expired: 'The link from the bot has expired. In the bot, open Settings → “Link Yandex or VK” again.',
    identity_taken: 'This account is already linked to another Boltaem profile with payments. Write to support — we’ll merge them.',
    web_login_taken: 'Another sign-in is already connected to your account. Use the same Yandex or VK as the first time.',
    legalBefore: 'By signing in, you accept the ',
    legalOffer: 'terms',
    legalAnd: ' and the ',
    legalPrivacy: 'privacy policy',
    legalConsentBefore: ' and give ',
    legalConsent: 'consent to personal data processing',
  },
  ru: {
    yandex: 'Войти с Яндекс ID',
    vk: 'Войти с VK ID',
    soon: 'скоро',
    failed: 'Не получилось войти. Попробуй ещё раз.',
    connect_expired: 'Ссылка из бота устарела. Открой в боте «Настройки» → «Привязать Яндекс или VK» ещё раз.',
    identity_taken: 'Этот аккаунт уже привязан к другому профилю Boltaem с оплатами. Напиши в поддержку — мы их объединим.',
    web_login_taken: 'К твоему аккаунту уже привязан другой вход. Войди тем же Яндексом или VK, что и в первый раз.',
    legalBefore: 'Входя, ты принимаешь условия ',
    legalOffer: 'оферты',
    legalAnd: ' и ',
    legalPrivacy: 'политики конфиденциальности',
    legalConsentBefore: ' и даёшь ',
    legalConsent: 'согласие на обработку персональных данных',
  },
};
